@if (_tempToShow) {
  <div class="asap-slider-content row">
    <ng-container>
      @if (!prevIcon) {
        <div class="asap-slider-icon prevPosition col-2 col-md-1" (click)="_onPrev()">
          <span class="prevNextGraphText">Previous<br/>graph</span>
        </div>
      }
      @if (prevIcon) {
        <div class="asap-slider-icon prevPosition col-2 col-md-1" [class.disabled]="!_showPrevIcon" (click)="_onPrev()">
          <img [src]="'/assets/menu/' + _theme + '/' + prevIcon" alt="Prev" /><br/><span class="prevNextGraphText">Previous<br/>graph</span>
        </div>
      }
    </ng-container>
    @for (template of _tempToShow; track template) {
      <div class="asap-slider-content-template col-8 col-md-10" [@sliderAnimation]>
        <ng-container *ngTemplateOutlet="template.template;"></ng-container>
      </div>
    }
    <ng-container>
      @if (!nextIcon) {
        <div class="asap-slider-icon nextPosition col-2 col-md-1" (click)="_onNext()">
          <span class="prevNextGraphText">next<br/>graph</span>
        </div>
      }
      @if (nextIcon) {
        <div class="asap-slider-icon nextPosition col-2 col-md-1"  [class.disabled]="!_showNextIcon" (click)="_onNext()">
          <img [src]="'/assets/menu/' + _theme + '/' + nextIcon" alt="Next" /><br/><span class="prevNextGraphText">next<br/>graph</span>
        </div>
      }
    </ng-container>
  </div>
}
